import React from 'react'
import { cn } from '@s4l/utility-css'
import styles from './index.module.css'
import Typography from '../../Typography'

interface SpinnerProps {
  text?: string
  color?: string
  position?: {
    top?: string
    bottom?: string
    left?: string
    right?: string
    transform?: string
  }
  iconOnly?: boolean
}

export function Spinner({ text, color, position, iconOnly = false }: Readonly<SpinnerProps>) {
  if (iconOnly) {
    return (
      <div
        className={styles.spinnerIcon}
        style={color ? ({ color } as React.CSSProperties) : undefined}
        data-testid="loader-spinner-icon"
      />
    )
  }

  return (
    <div
      className={cn(styles.loader, position && styles.hasPosition)}
      style={
        {
          ...position,
          ...(color ? { '--spinner-color': color } : null),
        } as React.CSSProperties
      }
      data-testid="loader"
    >
      <div className={styles.spinner} />
      {text && (
        <Typography
          variant="body"
          size="l"
          bold
          className={['display-none', 'tablet:display-block']}
        >
          {text}
        </Typography>
      )}
    </div>
  )
}
